import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function M() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');

    return (
        <div id="vanlife-M" className={`vanlife-M ${css['vanlife-M']}`}>
            <h2 className="title">{t('secM_title')}</h2>
            <p className="text h2-desc">
                {t.rich('secM_desc', {
                    a1: (text: string) => (
                        <Link className="desc-link" href={t('secM_desc_link1')}>
                            {text}
                        </Link>
                    ),
                    a2: (text: string) => (
                        <Link className="desc-link" href={t('secM_desc_link2')}>
                            {text}
                        </Link>
                    ),
                    a3: (text: string) => (
                        <Link className="desc-link" href={t('secM_desc_link3')}>
                            {text}
                        </Link>
                    ),
                })}
            </p>
            <div className="links">
                <Link className="link text" href={t('secM_link1')}>
                    {t('secM_link1_text')}
                </Link>
                <Link className="link text" href={t('secM_link2')}>
                    {t('secM_link2_text')}
                </Link>
                <Link className="link text" href={t('secM_link3')}>
                    {t('secM_link3_text')}
                </Link>
            </div>
        </div>
    );
}
